var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "outer-container" },
    [
      _c("header-menu"),
      _vm._v(" "),
      _c(
        "main",
        { staticClass: "container", attrs: { id: "routerView" } },
        [_c("router-view")],
        1
      ),
      _vm._v(" "),
      !["UserAgreement", "PrivacyPolicy", "PersonalDataAgreement"].includes(
        _vm.$route.name
      )
        ? _c("div", { staticClass: "bg-imgs" }, [
            _vm.showImgs.docs
              ? _c("img", {
                  staticClass: "bg-img bg-docs",
                  attrs: { src: require("images/background/docs.svg") },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.showImgs.lamp
              ? _c("img", {
                  staticClass: "bg-img bg-lamp",
                  attrs: { src: require("images/background/lamp.svg") },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.showImgs.phone
              ? _c("img", {
                  staticClass: "bg-img bg-phone",
                  attrs: { src: require("images/background/phone.svg") },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.showImgs.cup
              ? _c("img", {
                  staticClass: "bg-img bg-cup",
                  attrs: { src: require("images/background/cup.svg") },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.showImgs.monitor
              ? _c("img", {
                  staticClass: "bg-img bg-monitor",
                  attrs: { src: require("images/background/monitor.svg") },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.showImgs.cactus
              ? _c("img", {
                  staticClass: "bg-img bg-cactus",
                  attrs: { src: require("images/background/cactus.svg") },
                })
              : _vm._e(),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("footer-infomir"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }